/** localStorage that never throws: private windows and blocked storage must not break the app. */
export const store = {
  get<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(key)
      return raw === null ? fallback : (JSON.parse(raw) as T)
    } catch {
      return fallback
    }
  },
  set(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // storage full or disabled: the preference simply is not remembered
    }
  },
  remove(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch {
      // see above
    }
  },
}
